import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-[#085041] text-white/60 text-sm py-12 px-4">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 bg-[#1D9E75] rounded-xl flex items-center justify-center shadow">
              <span className="text-white font-bold text-sm">G</span>
            </div>
            <span className="font-bold text-white text-lg" style={{ fontFamily: "'Work Sans', sans-serif" }}>GuiaCit</span>
          </div>
          <p className="text-sm max-w-xs leading-relaxed">
            Encontre profissionais verificados para sua obra ou serviço. Rápido, seguro e confiável.
          </p>
        </div>

        <div className="flex gap-12 flex-wrap">
          <div>
            <p className="text-white font-semibold mb-3 text-sm">Profissionais</p>
            <div className="space-y-2">
              <Link to="/buscar" className="block hover:text-white transition-colors text-sm">Buscar</Link>
              <Link to="/cadastro" className="block hover:text-white transition-colors text-sm">Cadastrar-se</Link>
              <Link to="/entrar" className="block hover:text-white transition-colors text-sm">Entrar</Link>
            </div>
          </div>
          <div>
            <p className="text-white font-semibold mb-3 text-sm">Empresas</p>
            <div className="space-y-2">
              <Link to="/anunciante/cadastro" className="block hover:text-white transition-colors text-sm">Anunciar</Link>
              <Link to="/anunciante/entrar" className="block hover:text-white transition-colors text-sm">Login</Link>
            </div>
          </div>
          <div>
            <p className="text-white font-semibold mb-3 text-sm">Plataforma</p>
            <div className="space-y-2">
              <Link to="/promocoes" className="block hover:text-white transition-colors text-sm">Promoções</Link>
              <Link to="/sobra-de-obras" className="block hover:text-white transition-colors text-sm">Sobra de Obras</Link>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-2">
        <p>© 2025 GuiaCit. Todos os direitos reservados.</p>
        <p className="text-white/40">guiacit.com</p>
      </div>
    </footer>
  );
}
